import React from "react";
import PropTypes from "prop-types";
import * as Icon from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { colors } from "@/styles";
import { HeaderContainer, Title, BackButton, RightButton } from "./styles";

const Header = ({ 
  title, 
  backButtonVisible, 
  rightButtonVisible, 
  rightButtonIcon,
  onRightButtonClick,
  rightButtonContent,
  rightButtonStyle
}) => {
  const navigate = useNavigate();
  
  return (
    <HeaderContainer>
      {backButtonVisible && (
        <BackButton onClick={() => navigate(-1)}>
          <Icon.LeftOutlined style={{ color: colors.textPrimary }} />
        </BackButton>
      )}
      <Title>{title}</Title>
      {rightButtonVisible && (
        <RightButton 
          onClick={onRightButtonClick}
          style={rightButtonStyle}
        >
          {/* 🔑 支持自定义图标或内容 */}
          {rightButtonContent || (
            rightButtonIcon || 
            <Icon.SettingOutlined style={{ color: colors.textPrimary }} />
          )}
        </RightButton>
      )}
    </HeaderContainer>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  backButtonVisible: PropTypes.bool,
  rightButtonVisible: PropTypes.bool,
  rightButtonIcon: PropTypes.node, // 🔑 自定义图标
  onRightButtonClick: PropTypes.func, // 🔑 右侧按钮点击事件
  rightButtonContent: PropTypes.node, // 🔑 完全自定义右侧内容
  rightButtonStyle: PropTypes.object, // 🔑 自定义样式
};

Header.defaultProps = {
  backButtonVisible: true,
  rightButtonVisible: false,
  rightButtonIcon: null,
  onRightButtonClick: () => {},
  rightButtonContent: null,
  rightButtonStyle: {},
};

export default Header;
